export default __webpack_public_path__ + "static/media/about.bc270684.jpg";